import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navItems = [
    { path: '/shop', label: 'Shop' },
    { path: '/tailor', label: 'Tailor' },
    { path: '/design', label: 'Design' },
    { path: '/chat', label: 'Chat' },
    { path: '/opportunities', label: 'Opportunities' }
  ];

  return (
    <footer className="luxury-footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <h3 className="brand-name">ENERSTIC</h3>
            <p className="brand-tagline">Where luxury meets craftsmanship</p>
            <div className="social-links">
              <a href="/tailor" className="social-link">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="/tailor" className="social-link">
                <i className="fab fa-pinterest"></i>
              </a>
              <a href="/tailor" className="social-link">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="/tailor" className="social-link">
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>

          <div className="footer-nav-section">
            <h4>Navigation</h4>
            <div className="footer-nav">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => 
                    `footer-nav-link ${isActive ? 'active' : ''}`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>

          <div className="footer__features">
            <h4>Features</h4>
            <ul className="features__list">
              <li><a href="/tailorservices">Services</a></li>
              <li><a href="/tailorprofiles">Tailors</a></li>
              <li><a href="/tailor">About</a></li>
              <li><a href="/opportunities">Careers</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact__info">
              <p>📞 +27 64 944 7262</p>
              <p>✉️ contact@enerstic.com</p>
              <p>📍 123 Willows, Bloemfontein</p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__bottom_content">
            <p className="copyright">
              © {currentYear} ÉNERSTIC Fashion. All rights reserved.
            </p>
            <div className="legal__links">
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Service</a>
              <a href="cookies">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;